<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <!-- <side-bar
      :background-color="sidebarBackground"
      short-title="FM"
      title="FM"
    > -->
    <side-bar
      :background-color="sidebarBackground"
    >
      <template slot="links">
        <sidebar-item
          :link="{
            name: $t('dashboard'),
            icon: 'ni ni-tv-2 text-primary',
            path: '/'+$i18n.locale+'/dashboard'
          }"
        />
        <sidebar-item :link="{name: $t('checkin'), icon: 'ni ni-pin-3 text-yellow', path: '/'+$i18n.locale+'/checkin'}"/>
        <sidebar-item :link="{name: $t('member'), icon: 'ni ni-single-02 text-orange', path: '/'+$i18n.locale+'/member'}"/>
        <sidebar-item :link="{name: $t('history'), icon: 'ni ni-chart-bar-32 text-yellow', path: '/'+$i18n.locale+'/history'}"/>
        <sidebar-item :link="{name: $t('billing'), icon: 'ni ni-money-coins text-orange', path: '/'+$i18n.locale+'/billing'}"/>
        <!-- <sidebar-item :link="{name: 'Login', icon: 'ni ni-key-25 text-info', path: '/'+$i18n.locale+'/login'}"/>
        <sidebar-item :link="{name: 'Register', icon: 'ni ni-circle-08 text-pink', path: '/'+$i18n.locale+'/register'}"/> -->

      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
        <modal :show.sync="modal_active" :show-close="false">
            <h2 slot="header" class="modal-title" id="modal-title-default">{{$t('please_confirm_email')}}</h2>

            <p>{{$t('please_check_email_and_click')}}</p>

            <template slot="footer">
                <base-button @click="SendEmailConfirm()" type="primary">{{$t('send_again')}}</base-button>
                <base-button @click="goLogout()" type="danger">{{$t('logout')}}</base-button>
            </template>
        </modal>

        <modal :show.sync="modal_renew" :show-close="false">
            <h2 slot="header" class="modal-title" id="modal-title-default">{{$t('please_renew')}}</h2>

            <p>{{$t('profile_expired')}}</p>

            <template slot="footer">
                <base-button @click="Renew()" type="primary">{{$t('renew')}}</base-button>
                <base-button @click="goLogout()" type="danger">{{$t('logout')}}</base-button>
            </template>
        </modal>

        <modal :show.sync="modal_send_email">

            <p>{{$t('please_check_email')}}</p>

            <template slot="footer">
                <base-button @click="modal_send_email = false" type="primary">{{$t('close')}}</base-button>
            </template>

        </modal>

        <modal :show.sync="modal_renew_success">

            <p>{{$t('confirm_success')}}</p>

            <template slot="footer">
                <base-button @click="modal_renew_success = false, modal_renew = false" type="primary">{{$t('close')}}</base-button>
            </template>

        </modal>

        <modal :show.sync="modal"
               :gradient="modal_setting.gradient"
               modal-classes="modal-danger modal-dialog-centered">
            <div class="py-3 text-center">
                <i class="ni ni-bell-55 ni-3x"></i>
                <h4 class="heading mt-4"></h4>
                <p>{{modal_setting.alert_text}}</p>
            </div>

            <template slot="footer">
                <base-button type="link"
                             text-color="white"
                             class="ml-auto"
                             @click="modal = false">
                    {{$t('close')}}
                </base-button>
            </template>
        </modal>
  </div>
</template>
<script>
  import i18n from "@/i18n"
  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      FadeTransition
    },
    data() {
      return {
        sidebarBackground: 'vue', //vue|blue|orange|green|red|primary
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        modal_active: false,
        modal_renew: false,
        modal_send_email: false,
        modal_renew_success: false
      };
    },
    created () {
        this.getProfile()
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },
      getProfile () {
            this.$http.get('profile')
                .then(request => this.getProfileSuccessful(request))
                .catch(() => this.getProfileFailed())
        },
        getProfileSuccessful (req) {
            if (req.data.code !== '0') {
                this.getProfileFailed(req)
                return
            }
            this.$store.commit('addprofile', req.data.data)
            this.checkActive()
        },
        getProfileFailed (req) {
            this.$store.commit('addtoken', '')
            this.$store.commit('addprofile', '')
            this.$store.commit('addgyms', '')
            this.modalAlert(req)
        },
      checkActive () {
        if(this.$store.state.profile.status === 'new') {
          this.modal_active = true
        }
        if(this.$store.state.profile.status === 'expired') {
          this.modal_renew = true
        }
      },
      modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
        },
        goLogout () {
            this.modal_active = false
            this.modal_renew = false
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/logout')
        },
        SendEmailConfirm () {
            this.$http.post('profile/resendEmail')
                .then(request => this.SendEmailConfirmSuccessful(request))
                .catch(() => this.SendEmailConfirmFailed())
        },
        SendEmailConfirmSuccessful (req) {
            if (req.data.code !== '0') {
                this.SendEmailConfirmFailed(req)
                return
            }
            this.modal_send_email = true
        },
        SendEmailConfirmFailed (req) {
            this.modalAlert(req)
        },
        Renew () {
            this.$http.post('profile/renew')
                .then(request => this.RenewSuccessful(request))
                .catch(() => this.RenewFailed())
        },
        RenewSuccessful (req) {
            if (req.data.code !== '0') {
                this.RenewFailed(req)
                return
            }
            this.modal_renew_success = true
        },
        RenewFailed (req) {
            this.modalAlert(req)
        },
    }
  };
</script>
<style lang="scss">
</style>
